import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Box, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, Typography } from '@mui/material';
import axios from 'axios';
import useSWR from 'swr';
import { apiHost } from '../utils/apiHost';
import { UlasanGoogleCard } from './UlasanGoogleCard';
import { KartuUlasan } from './KartuUlasan';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};
const api = axios.create({ baseURL: getApiBaseUrl(), withCredentials: true });
const fetcher = (url) => api.get(url).then((r) => r.data);

/**
 * Menu Ulasan Google: tautan ulasan tiap cabang (dari tautan Google Maps atau cari otomatis) dan kartu QR siap cetak.
 * Tautan yang sama dipakai di QR struk (sakelar di menu Struk), layar pelanggan, dan menu QR pelanggan.
 */
export const UlasanGoogleHalaman = () => {
  const { user } = useSelector((state) => state.auth);
  const isSuperAdmin = user?.role === 'superadmin';
  const cabangSendiri = user?.cabang?.uuid || user?.cabanguuid || '';
  const [pilihCabang, setPilihCabang] = useState('');
  const [tab, setTab] = useState(0);
  const cabangUuid = isSuperAdmin ? pilihCabang : cabangSendiri;
  const { data: daftarCabang } = useSWR(isSuperAdmin ? '/cabang' : null, fetcher);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, pb: { xs: 4, md: 5 } }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>Ulasan Google</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Ajak pelanggan memberi ulasan di Google lewat QR: isi tautan ulasan cabang, lalu cetak kartu QR untuk standing acrylic atau stiker.
        QR juga bisa dicetak di bawah struk (diatur di menu Struk), tampil di layar pelanggan, dan di menu QR.
      </Typography>

      {isSuperAdmin && (
        <FormControl size="small" sx={{ minWidth: 260, mb: 2 }}>
          <InputLabel id="label-cabang-ulasan">Cabang</InputLabel>
          <Select labelId="label-cabang-ulasan" label="Cabang" value={pilihCabang} onChange={(e) => setPilihCabang(e.target.value)}>
            {(daftarCabang?.data || daftarCabang || []).map((c) => <MenuItem key={c.uuid} value={c.uuid}>{c.namacabang}</MenuItem>)}
          </Select>
        </FormControl>
      )}

      {!cabangUuid ? (
        <Alert severity="info">Pilih cabang dulu.</Alert>
      ) : (
        <>
          <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
            <Tab label="Tautan ulasan" />
            <Tab label="Kartu QR cetak" />
          </Tabs>
          {tab === 0 && <UlasanGoogleCard cabangUuid={cabangUuid} onCetakKartu={() => setTab(1)} />}
          {tab === 1 && <KartuUlasan cabangUuid={cabangUuid} onIsiTautan={() => setTab(0)} />}
        </>
      )}
    </Box>
  );
};

export default UlasanGoogleHalaman;
